import { useState, useEffect } from "react";
import { Navigate, useLocation } from 'react-router-dom'
import Header from '../Header/Header'
// ------ Services ------ //
import LeadCaptureHeader from '../Header/LeadCaptureHeader'
import * as clientEventService from '../../services/clientEventService'

const ProtectedRoute = ({ user, children }) => {
    const { pathname } = useLocation();
    const [clientEventInfo, setClientEventInfo] = useState({})
    useEffect(() => {
        const localclientevent = clientEventService.getClientEvent();
        if (localclientevent) {
            setClientEventInfo(localclientevent);
        }
    }, [])

    useEffect(() => {
        // 
    }, [clientEventInfo])
    // list all pages that should receive Header Component - client/event selection
    const headerArray = [/*Home*/'eventbadgesmanager', 'eventsetting/eventfilterlistmanager', 'eventfilterlistmanager', 'eventsetting/guesteventfilterlist', 'guesteventfilterlist',
        'eventsetting/eventfilterlistmanager', 'eventfilterlistmanager', 'eventload', 'clientload', 'eventsetting',
        /*Badging*/'badgeimagemanager', 'badgescannerimagemanager', 'badgetemplatefieldordering', 'badgetemplateindex', 'badgetemplatemanager', 'guestbadgetemplatemanager',
        'badgetoerspropertymappingmanager', 'badgetoerspropertymapping', 'badgetoerspropertyguestmapping',
        'extrabadgemanager', 'extrabadgetemplatefieldordering', 'guestbadgetemplatefieldordering', 'extrabadgetemplatemanager', 'extrabadgetemplatestyling', 'kioskeditscreenlayout',
        'kiosklandingpagesetup', 'guestbadgetemplatestyling', 'registranttoguestmapping', 'flattemplatesetup',
        'kioskmanager', 'kioskscannerpagesetup', 'kiosksetup', 'mainbadgetemplatestyling', 'printpreview', 'regtypemapping', 'staticfieldmanager',
        'attendancereport', 'adminprint', 'adminprintflat', 'adhocprint', 'adhocprintflat', 
        /*Home*/'eventsetting/webhooklist',  'viewgenerate',
        /**/'clienteventdata', /*'clientlist',*/ 'eventsetting', 'eventspecificstatuspage'];
    const leadCaptureHeaderArray = [/*LeadCapture*/'exhibitorlist', /*'leadcaptureconfig'*/, 'leadcapturelist', 'leadcapturereports', 'leadcapturesetting'];
    // redirect to login
    if (!user) { return <Navigate to="/" replace={true} /> }
    // redirect to kiosk path
    var pathLower = pathname.toLowerCase();
    if (user.Role === "SiteUser" && !pathLower.includes("/kiosk/")) {
        if ((user.flatSetup) || (clientEventInfo && clientEventInfo.flatSetup) ) {
            return (<Navigate to={"/Kiosk/KioskFullFlat"} replace={true} state={{ user: {user} }} />);
        }
        return (<Navigate to={"/Kiosk/KioskFull"} replace={true} state={{ user: { user } }} />);
    }
    var pathArray = pathLower.split('/');
    
    if ((!pathLower.includes("/kiosk/") && headerArray.includes(pathLower.replace('/', ""))) ||
        (pathArray && pathArray.length > 2 && !pathLower.includes("/kiosk/")
            && headerArray.includes(pathArray[1].replace('/', "")))) {

        // include header
        return (
            <div>
                <Header user={user} />
                <div>{children}</div>
            </div>
        );
    }
    if ((!pathLower.includes("/kiosk/") && leadCaptureHeaderArray.includes(pathLower.replace('/', ""))) ||
        (pathArray && pathArray.length > 2 && !pathLower.includes("/kiosk/")
        && leadCaptureHeaderArray.includes(pathArray[1].replace('/', "")))) {

        // include lead capture header
        return (
            <div>
                <LeadCaptureHeader user={user} />
                <div>{children}</div>
            </div>
        );
    }

    return children
}

export default ProtectedRoute